import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export const UrgencyCountdown: React.FC = () => {
  // Start with 23:47:18
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 47,
    seconds: 18
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else {
          seconds = 59;
          if (minutes > 0) {
            minutes--;
          } else {
            minutes = 59;
            if (hours > 0) {
              hours--;
            }
          }
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <>
      <section className="bg-gradient-to-br from-red-dark to-red-main py-[30px] px-5 text-center text-white" data-id="element-270">
        <div className="text-sm font-sans font-bold tracking-[2px] uppercase opacity-90 mb-3" data-id="element-271">
          ⏰ Precio de lanzamiento — Cierra en:
        </div>
        <div className="flex justify-center gap-2 items-center mb-3 md:gap-1.5" data-id="element-272">
          <div className="bg-black/30 rounded-lg py-2.5 px-4 min-w-[60px] md:min-w-[50px] md:py-2 md:px-3" data-id="element-273">
            <span className="block text-[32px] font-black leading-none font-sans" data-id="element-274">
              {formatTime(timeLeft.hours)}
            </span>
            <span className="block text-[11px] font-sans opacity-80 uppercase tracking-[1px] mt-0.5" data-id="element-275">
              hs
            </span>
          </div>
          <span className="text-[28px] font-black opacity-70 mb-1.5" data-id="element-276">:</span>
          <div className="bg-black/30 rounded-lg py-2.5 px-4 min-w-[60px] md:min-w-[50px] md:py-2 md:px-3" data-id="element-277">
            <span className="block text-[32px] font-black leading-none font-sans" data-id="element-278">
              {formatTime(timeLeft.minutes)}
            </span>
            <span className="block text-[11px] font-sans opacity-80 uppercase tracking-[1px] mt-0.5" data-id="element-279">
              min
            </span>
          </div>
          <span className="text-[28px] font-black opacity-70 mb-1.5" data-id="element-280">:</span>
          <div className="bg-black/30 rounded-lg py-2.5 px-4 min-w-[60px] md:min-w-[50px] md:py-2 md:px-3" data-id="element-281">
            <span className="block text-[32px] font-black leading-none font-sans" data-id="element-282">
              {formatTime(timeLeft.seconds)}
            </span>
            <span className="block text-[11px] font-sans opacity-80 uppercase tracking-[1px] mt-0.5" data-id="element-283">
              seg
            </span>
          </div>
        </div>
        <p className="text-sm font-sans opacity-90" data-id="element-284">
          ⚠️ Después sube <strong className="text-gold-main" data-id="element-285">$8.000 ARS</strong>
          . No vuelve al precio actual.
        </p>
      </section>

      <div className="bg-[#FFF8F0] p-5 text-center" data-id="element-286">
        <div className="text-sm font-sans text-brown-light font-bold mb-2" data-id="element-287">
          🔴 Cupos al precio de lanzamiento
        </div>
        <div className="max-w-[400px] mx-auto bg-[#E8E8E8] rounded-full h-[14px] overflow-hidden" data-id="element-288">
          <motion.div className="h-full bg-gradient-to-r from-brown-light to-red-main rounded-full" initial={{
          width: '0%'
        }} animate={{
          width: '68%'
        }} transition={{
          duration: 2,
          ease: 'easeOut'
        }} data-id="element-289" />
        </div>
        <p className="text-xs text-[#999] font-sans mt-1.5" data-id="element-290">
          68% de los cupos al precio de lanzamiento ya tomados
        </p>
      </div>
    </>;
};